import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import * as hairProductContent from 'assets/content/haircareProducts';
import * as skinProductContent from 'assets/content/skincareProducts';

const products = { ...hairProductContent, ...skinProductContent };

export const getMembershipState = (state: RootState) => state.membership;

export const getMembershipStatus = createSelector(getMembershipState, (state) => state.status);

export const getMemberSince = createSelector(
  getMembershipState,
  (state) => state.data?.member_since,
);
export const getNumberOfProductBoughtSinceLastUnlock = createSelector(
  getMembershipState,
  (state) => state.data?.number_of_product_bought_since_last_unlock,
);
const getNumberOfPendingSelectionProducts = createSelector(
  getMembershipState,
  (state) => state.data?.number_of_pending_selection_products || 0,
);
export const getCurrentSelectedFreeProduct = createSelector(
  getMembershipState,
  (state) => state.currentSelectedFreeProduct,
);
export const getCurrentSelectedFreeProductSlug = createSelector(
  getCurrentSelectedFreeProduct,
  (currentSelectedFreeProduct) => currentSelectedFreeProduct?.slug,
);
export const getExpirationDate = createSelector(
  getCurrentSelectedFreeProduct,
  (currentSelectedFreeProduct) => currentSelectedFreeProduct?.expired_at,
);

export const getFreeProductCatalog = createSelector(
  getMembershipState,
  (state) => state.data?.free_product_catalog ?? [],
);

// Computed Derived State
export const canSelectFreeProduct = createSelector(
  getNumberOfPendingSelectionProducts,
  (pendingSelections) => pendingSelections >= 1,
);

export const getSelectedComplimentaryProductLabel = createSelector(
  getCurrentSelectedFreeProductSlug,
  (selectedSlug) => (selectedSlug && products[selectedSlug].label) ?? null,
);

export const getSelectedComplimentaryProductPicture = createSelector(
  getCurrentSelectedFreeProductSlug,
  (selectedSlug) => (selectedSlug && products[selectedSlug].picture) ?? null,
);
